<template>
  <div class="Dashbord">
    <FloatingButton></FloatingButton>
    <ActionsNav></ActionsNav>
    <div class="Actions__Content">
      <v-container fluid>
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->
        <section
          class="TankRoom"
          v-for="item in items"
          :key="item.warehouseType.id"
        >
          <template
            v-if="vinarija && item.warehouseType.enumLable === 'bottled_wine'"
          >
            <h2>
              <span>{{ item.warehouseType.name }}</span>
              <router-link
                :to="{
                  name: 'warehouse_type',
                  params: {
                    id: item.warehouseType.id,
                    warehouse_type_name: item.warehouseType.name,
                  },
                }"
                class="moreInfo"
              >
                Više informacija
                <i class="fa fa-chevron-right"></i>
              </router-link>
            </h2>

            <template v-if="item.warehouse.length < visak">
              <div class="TankHolder">
                <div v-for="warehouse in item.warehouse" :key="warehouse.id">
                  <template>
                    <div
                      :class="'Tank ' + warehouse.warehouseType.enumLable"
                      :key="warehouse.id"
                      :data-warehouse-id="warehouse.id"
                      :data-warehouse-type="warehouse.warehouseType.enumLable"
                      :data-warehouse-type-id="warehouse.warehouseType.id"
                      :data-warehouse-name="warehouse.name"
                      @click="selectTank(warehouse)"
                    >
                      <!-- <div class="Tank__Bar">
                      <div class="bar">
                        <span
                          class="bar_Fill"
                          :style="'height: '+  100 * warehouse.quantity/warehouse.capacity + '%'"
                        ></span>
                        <span class="bar_Bkg"></span>
                      </div>
                    </div> -->

                      <!-- /.Tank__Bar -->
                      <div class="Tank__Content">
                        <!-- <p class="vineType">{{ warehouse.name }} </p> -->

                        <p
                          class="vineType"
                          v-if="warehouse.name === undefined"
                        ></p>
                        <!-- <p
                  class="vineType" v-else-if="warehouse.name.length <= 26"
                >{{ warehouse.name}}</p> -->
                        <!-- <p
                  class="vineType" 
                 :title=warehouse.name v-else
                >{{ warehouse.name.substring(0, 25)}}...</p> -->

                        <!-- <div class="columnVineType" style="">{{ warehouse.name }} {{ 202020 }}
                        <div class="columnRightVineType">{{warehouse.phase}}</div>
                        </div> -->

                        <h4 v-if="warehouse.name.length <= 20">
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            >{{ warehouse.name }}</router-link
                          >
                        </h4>
                        <h4 v-else>
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            :title="warehouse.name"
                            >{{
                              warehouse.name.substring(0, 19)
                            }}...</router-link
                          >
                        </h4>
                        <div class="Tank__Img">
                          <img
                            :src="'../assets/iconsTanks/vina.png'"
                            alt="Tank Image"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          />
                          <img
                            :src="'../assets/iconsTanks/repromaterijal.png'"
                            alt="Tank Image"
                            v-else
                          />
                        </div>
                        <!-- /.Tank__Img -->

                        <div class="Tank__Info">
                          <p
                            class="amauntAvailable"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          >
                            {{
                              warehouse.bottlesSum !== null
                                ? formatInt(warehouse.bottlesSum) + " boca"
                                : " - "
                            }}
                          </p>
                          <p class="amauntAvailable" v-else>
                            {{
                              warehouse.materialValueValue !== null
                                ? currencyFormatDE(
                                    warehouse.materialValueValue
                                  ) + " RSD"
                                : " - "
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- /.Tank__Content -->
                </div>
                <!-- /.Tank -->
              </div>
              <!-- /.TankHolder -->
            </template>
            <template v-else>
              <div class="TankHolder">
                <div
                  v-for="warehouse in item.warehouse.slice(0, visak)"
                  :key="warehouse.id"
                >
                  <template v-if="warehouse.name === null">
                    <div
                      :class="'Tank '"
                      :key="warehouse.id"
                      :data-warehouse-id="warehouse.id"
                      :data-warehouse-type="warehouse.warehouseType.enumLable"
                      :data-warehouse-type-id="warehouse.warehouseType.id"
                      :data-warehouse-name="warehouse.name"
                      @click="selectTank(warehouse)"
                    >
                      <!-- <div class="Tank__Bar">
                      <div class="bar">
                        <span
                          class="bar_Fill"
                          :style="'height: '+  100 * warehouse.quantity/warehouse.capacity + '%'"
                        ></span>
                        <span class="bar_Bkg"></span>
                      </div>
                    </div> -->
                      <!-- /.Tank__Bar -->
                      <div class="Tank__Content">
                        <p class="vineType">Prazan tank</p>
                        <h4>
                          <router-link
                            :to="{
                              name: 'empty_tank',
                              params: { id: warehouse.id },
                            }"
                            >{{ warehouse.name }}</router-link
                          >
                        </h4>
                        <div class="Tank__Img">
                          <img
                            :src="'../assets/iconsTanks/vina.png'"
                            alt="Tank Image"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          />
                          <img
                            :src="'../assets/iconsTanks/repromaterijal.png'"
                            alt="Tank Image"
                            v-else
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      :class="'Tank ' + warehouse.warehouseType.enumLable"
                      :key="warehouse.id"
                      :data-warehouse-id="warehouse.id"
                      :data-warehouse-type="warehouse.warehouseType.enumLable"
                      :data-warehouse-type-id="warehouse.warehouseType.id"
                      :data-warehouse-name="warehouse.name"
                      @click="selectTank(warehouse)"
                    >
                      <!-- <div class="Tank__Bar">
                      <div class="bar">
                        <span
                          class="bar_Fill"
                          :style="'height: '+  100 * warehouse.quantity/warehouse.capacity + '%'"
                        ></span>
                        <span class="bar_Bkg"></span>
                      </div>
                    </div> -->
                      <!-- /.Tank__Bar -->
                      <div class="Tank__Content">
                        <!-- <p class="vineType">{{ warehouse.name }}</p> -->

                        <p
                          class="vineType"
                          v-if="warehouse.name === undefined"
                        ></p>
                        <h4 v-if="warehouse.name.length <= 20">
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            >{{ warehouse.name }}</router-link
                          >
                        </h4>
                        <h4 v-else>
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            :title="warehouse.name"
                            >{{
                              warehouse.name.substring(0, 19)
                            }}...</router-link
                          >
                        </h4>
                        <div class="Tank__Img">
                          <img
                            :src="'../assets/iconsTanks/vina.png'"
                            alt="Tank Image"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          />
                          <img
                            :src="'../assets/iconsTanks/repromaterijal.png'"
                            alt="Tank Image"
                            v-else
                          />
                        </div>
                        <!-- /.Tank__Img -->

                        <div class="Tank__Info">
                          <p
                            class="amauntAvailable"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          >
                            {{
                              warehouse.bottlesSum !== null
                                ? formatInt(warehouse.bottlesSum) + " boca"
                                : " - "
                            }}
                          </p>
                          <p class="amauntAvailable" v-else>
                            {{
                              warehouse.materialValueValue !== null
                                ? currencyFormatDE(
                                    warehouse.materialValueValue
                                  ) + " RSD"
                                : " - "
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- /.Tank__Content -->
                </div>
                <!-- /.Tank -->
              </div>
              <!-- /.TankHolder -->
            </template>
          </template>
          <template v-if="item.warehouseType.enumLable !== 'bottled_wine'">
            <h2>
              <span>{{ item.warehouseType.name }}</span>
              <router-link
                :to="{
                  name: 'warehouse_type',
                  params: {
                    id: item.warehouseType.id,
                    warehouse_type_name: item.warehouseType.name,
                  },
                }"
                class="moreInfo"
              >
                Više informacija
                <i class="fa fa-chevron-right"></i>
              </router-link>
            </h2>

            <template v-if="item.warehouse.length < visak">
              <div class="TankHolder">
                <div v-for="warehouse in item.warehouse" :key="warehouse.id">
                  <template>
                    <div
                      :class="'Tank ' + warehouse.warehouseType.enumLable"
                      :key="warehouse.id"
                      :data-warehouse-id="warehouse.id"
                      :data-warehouse-type="warehouse.warehouseType.enumLable"
                      :data-warehouse-type-id="warehouse.warehouseType.id"
                      :data-warehouse-name="warehouse.name"
                      @click="selectTank(warehouse)"
                    >
                      <!-- <div class="Tank__Bar">
                      <div class="bar">
                        <span
                          class="bar_Fill"
                          :style="'height: '+  100 * warehouse.quantity/warehouse.capacity + '%'"
                        ></span>
                        <span class="bar_Bkg"></span>
                      </div>
                    </div> -->

                      <!-- /.Tank__Bar -->
                      <div class="Tank__Content">
                        <!-- <p class="vineType">{{ warehouse.name }} </p> -->

                        <p
                          class="vineType"
                          v-if="warehouse.name === undefined"
                        ></p>
                        <!-- <p
                  class="vineType" v-else-if="warehouse.name.length <= 26"
                >{{ warehouse.name}}</p> -->
                        <!-- <p
                  class="vineType" 
                 :title=warehouse.name v-else
                >{{ warehouse.name.substring(0, 25)}}...</p> -->

                        <!-- <div class="columnVineType" style="">{{ warehouse.name }} {{ 202020 }}
                        <div class="columnRightVineType">{{warehouse.phase}}</div>
                        </div> -->

                        <h4 v-if="warehouse.name.length <= 20">
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            >{{ warehouse.name }}</router-link
                          >
                        </h4>
                        <h4 v-else>
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            :title="warehouse.name"
                            >{{
                              warehouse.name.substring(0, 19)
                            }}...</router-link
                          >
                        </h4>
                        <div class="Tank__Img">
                          <img
                            :src="'../assets/iconsTanks/vina.png'"
                            alt="Tank Image"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          />
                          <img
                            :src="'../assets/iconsTanks/repromaterijal.png'"
                            alt="Tank Image"
                            v-else
                          />
                        </div>
                        <!-- /.Tank__Img -->

                        <div class="Tank__Info">
                          <p
                            class="amauntAvailable"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          >
                            {{
                              warehouse.bottlesSum !== null
                                ? formatInt(warehouse.bottlesSum) + " boca"
                                : " - "
                            }}
                          </p>
                          <p class="amauntAvailable" v-else>
                            {{
                              warehouse.materialValueValue !== null
                                ? currencyFormatDE(
                                    warehouse.materialValueValue
                                  ) + " RSD"
                                : " - "
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- /.Tank__Content -->
                </div>
                <!-- /.Tank -->
              </div>
              <!-- /.TankHolder -->
            </template>
            <template v-else>
              <div class="TankHolder">
                <div
                  v-for="warehouse in item.warehouse.slice(0, visak)"
                  :key="warehouse.id"
                >
                  <template v-if="warehouse.name === null">
                    <div
                      :class="'Tank '"
                      :key="warehouse.id"
                      :data-warehouse-id="warehouse.id"
                      :data-warehouse-type="warehouse.warehouseType.enumLable"
                      :data-warehouse-type-id="warehouse.warehouseType.id"
                      :data-warehouse-name="warehouse.name"
                      @click="selectTank(warehouse)"
                    >
                      <!-- <div class="Tank__Bar">
                      <div class="bar">
                        <span
                          class="bar_Fill"
                          :style="'height: '+  100 * warehouse.quantity/warehouse.capacity + '%'"
                        ></span>
                        <span class="bar_Bkg"></span>
                      </div>
                    </div> -->
                      <!-- /.Tank__Bar -->
                      <div class="Tank__Content">
                        <p class="vineType">Prazan tank</p>
                        <h4>
                          <router-link
                            :to="{
                              name: 'empty_tank',
                              params: { id: warehouse.id },
                            }"
                            >{{ warehouse.name }}</router-link
                          >
                        </h4>
                        <div class="Tank__Img">
                          <img
                            :src="'../assets/iconsTanks/vina.png'"
                            alt="Tank Image"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          />
                          <img
                            :src="'../assets/iconsTanks/repromaterijal.png'"
                            alt="Tank Image"
                            v-else
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      :class="'Tank ' + warehouse.warehouseType.enumLable"
                      :key="warehouse.id"
                      :data-warehouse-id="warehouse.id"
                      :data-warehouse-type="warehouse.warehouseType.enumLable"
                      :data-warehouse-type-id="warehouse.warehouseType.id"
                      :data-warehouse-name="warehouse.name"
                      @click="selectTank(warehouse)"
                    >
                      <!-- <div class="Tank__Bar">
                      <div class="bar">
                        <span
                          class="bar_Fill"
                          :style="'height: '+  100 * warehouse.quantity/warehouse.capacity + '%'"
                        ></span>
                        <span class="bar_Bkg"></span>
                      </div>
                    </div> -->
                      <!-- /.Tank__Bar -->
                      <div class="Tank__Content">
                        <!-- <p class="vineType">{{ warehouse.name }}</p> -->

                        <p
                          class="vineType"
                          v-if="warehouse.name === undefined"
                        ></p>
                        <h4 v-if="warehouse.name.length <= 20">
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            >{{ warehouse.name }}</router-link
                          >
                        </h4>
                        <h4 v-else>
                          <router-link
                            :to="{
                              name: 'ware_house_list',
                              params: {
                                id: warehouse.id,
                                name: warehouse.name,
                                type: warehouse.warehouseType.enumLable,
                                typeId: warehouse.warehouseType.id,
                              },
                            }"
                            :title="warehouse.name"
                            >{{
                              warehouse.name.substring(0, 19)
                            }}...</router-link
                          >
                        </h4>
                        <div class="Tank__Img">
                          <img
                            :src="'../assets/iconsTanks/vina.png'"
                            alt="Tank Image"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          />
                          <img
                            :src="'../assets/iconsTanks/repromaterijal.png'"
                            alt="Tank Image"
                            v-else
                          />
                        </div>
                        <!-- /.Tank__Img -->

                        <div class="Tank__Info">
                          <p
                            class="amauntAvailable"
                            v-if="
                              warehouse.warehouseType.enumLable ===
                              'bottled_wine'
                            "
                          >
                            {{
                              warehouse.bottlesSum !== null
                                ? formatInt(warehouse.bottlesSum) + " boca"
                                : " - "
                            }}
                          </p>
                          <p class="amauntAvailable" v-else>
                            {{
                              warehouse.materialValueValue !== null
                                ? currencyFormatDE(
                                    warehouse.materialValueValue
                                  ) + " RSD"
                                : " - "
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- /.Tank__Content -->
                </div>
                <!-- /.Tank -->
              </div>
              <!-- /.TankHolder -->
            </template>
          </template>
        </section>
      </v-container>
    </div>
    <!-- /.Actions__Content -->
    <TokenComponent ref="frmtoken" />
  </div>
  <!-- /.Dashboard -->
</template>

<script>
import TokenComponent from "../components/Token";
import { serverBus } from "../main";
import { readJSON, daLiJeVinarija } from "../helpers/Functions";

import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
//Parts
import ActionsNav from "./parts/ActionsNavMagacin";
import FloatingButton from "./parts/FloatingButtonMultiMagacin";

// const MountedMixin = {
// 	mounted() {
// 		//alert(1);
// 		this.$emit("mounted");
// 	}
// };

export default {
  name: "ware_houses",
  dialog: false,
  components: {
    Breadcrumbs,
    ActionsNav,
    FloatingButton,
    TokenComponent,
  },
  data() {
    return {
      // rooms: [],
      // tanks: [],
      actionId: 0,
      items: [],
      all_grape_input_items: [],
      kolicina_vina_u_bacvi: 0,
      akcija: 0,
      floating_akcija: "3",
      window: {
        width: 0,
      },
      vinarija: true,
      visak: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;

      // alert(this.window.width);

      this.visak = Math.floor((this.window.width - 185) / 183);
      //alert(this.koliko_tankova_2);
    },
    formatInt(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    currencyFormatDE(num) {
      return num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    selectTank: function (warehouse) {
      let pomInt = 9999;
      let tanks = document.getElementsByClassName("Tank");

      for (let i = 0; i < tanks.length; i++) {
        tanks[i].classList.remove("active");

        if (tanks[i].dataset.warehouseId === warehouse.id.toString()) {
          let nizVrednosti; // = [false, false, false, false, false, true, true, false, true];

          if (tanks[i].dataset.warehouseType === "bottled_wine")
            nizVrednosti = [
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
            ];
          else
            nizVrednosti = [
              false,
              false,
              false,
              false,
              false,
              true,
              false,
              false,
            ];

          serverBus.$emit("disable_action_warehouse", nizVrednosti);

          pomInt = i;
        }
        if (pomInt != 9999) {
          tanks[pomInt].classList.add("active");
        }
      }
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_type/warehouses",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_type/warehouses",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items = response.data;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },

  beforeMount() {
    serverBus.$off("ucitaj_podatke");
    this.getAllSifarnik();

    serverBus.$on("ucitaj_podatke", () => {
      // alert('ucitaj_podatke');

      this.getAllSifarnik();
    });
  },

  mounted() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/sass/parts/_warehousesType.scss";

.column {
  float: left;
}

.columnVineType {
  float: left;
  text-align: left;
  margin-bottom: 0px;
}

.columnRight {
  float: right;
  color: #8e302f;
  font-weight: bold;
}

.columnRightVineType {
  float: right;
  color: #018389;
  font-weight: bold;
  padding-left: 5px;
}
/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>
